import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { projectSettingsSoftwareNotificationsRoute } from '@jira/router-routes__project-settings-product-routes-software-routes/src/projectSettingsSoftwareNotificationsRoute.tsx';
import { softwareProjectLayoutNoOnboarding } from '@jira/platform__layouts-software-project-layout/src/index.tsx';
import type { Route } from '@atlassian/react-resource-router';
import { getSettingsNavigationResources } from './ui/project-settings/product-routes/common/index.tsx';
import SoftwareNotifications, {
	LazySoftwareNotificationsSettings,
} from './ui/project-settings/software-notifications/index.tsx';

export const projectSettingsSoftwareNotificationsRouteEntry: Route = createEntry(
	projectSettingsSoftwareNotificationsRoute,
	() => ({
		group: 'project-settings-software',
		ufoName: 'project-settings.software.notifications',
		// eslint-disable-next-line no-restricted-syntax
		component: SoftwareNotifications,
		layout: softwareProjectLayoutNoOnboarding,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [...getSettingsNavigationResources()],
		forPaint: [LazyAtlassianNavigation, LazySoftwareNotificationsSettings],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
